/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  message,
} from 'antd';
import {
} from '@ant-design/icons';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { onError } from 'utils/handlers';
import {
  deleteAgentePolicial,
  getAgentePolicial,
  getAgentesPoliciales,
  patchAgentePolicial,
  postAgentePolicial,
} from 'api/catalogos/agentesPoliciales';
import {
  getDepartamentos,
} from 'api/configuracion/departamentos';
import BusquedaAvanzadaUsers from 'components/BusquedaAvanzadaCajeros';
import { ActionsNames, hasActionPermission } from 'utils/permission/index';
import { InputSearchPro } from 'components/InputSearch';
import TextArea from 'antd/lib/input/TextArea';
import { getUsuario, getUsuarios } from 'api/usuarios/usuarios';
import { useSelector } from 'react-redux';
import { defConfigDeInfraccion } from './Catalogos/CatalogoDeInfracciones';

const baseURI = 'catalogos/agentes-policiales/';

const models = ['agentepolicial'];

const Agente = ({ permission }) => {
  const configDeInfraccion = useSelector(({ auth }) => auth.entidad.configuracion_de_infraccion)
    || defConfigDeInfraccion;
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const [departamentos, setDepartamentos] = useState([]);
  const [visibleAdvancedUser, setVisibleAdvancedUser] = useState(false);
  const [usuarioFound, setUsuarioFound] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getAgentesPoliciales();
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    let _hasAllPermission = true;
    const validatePermission = () => {
      const _hasAllViewPermission = models
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        _hasAllPermission = _hasAllViewPermission;
        setHasAllViewPermission(_hasAllViewPermission);
      }
    };
    const fetchAll = async () => {
      setLoading(true);
      const [_data, _departamentos] = await Promise.all([
        getAgentesPoliciales(),
        getDepartamentos(),
      ]);
      if (mounted) {
        setData(_data);
        setDepartamentos(_departamentos);
        setLoading(false);
      }
    };

    validatePermission();
    if (_hasAllPermission) {
      fetchAll();
    }
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
    setUsuarioFound([]);
  };

  const fetchUser = async (id) => {
    setLoading(true);
    if (id) {
      const _user = await getUsuario(id?.id || id);
      if (_user) {
        form.setFieldsValue({
          usuario: _user.id,
        });
        const matched = {
          ..._user,
          nombre_completo: `${_user?.first_name} ${_user?.last_name
            || ''} ${_user?.second_last_name || ''}`,
        };
        setUsuarioFound(matched);
      } else {
        message.info('No se encontró usuario');
      }
    }
    setLoading(false);
  };

  const onClickEdit = async (AgenteId) => {
    const key = selectedRowKeys[0] || AgenteId;
    const match = await getAgentePolicial(key);
    if (match) {
      await fetchUser(key);
      form.setFieldsValue(match);
    }
    setVisible(true);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      const saved = await (key ? patchAgentePolicial(key, values)
        : postAgentePolicial(values));
      if (saved) {
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteAgentePolicial(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const searchUsuario = async () => {
    try {
      setLoading(true);
      await form.validateFields(['q']);
      const { q: email } = form.getFieldsValue();
      const resUser = await getUsuarios({ email });

      if (resUser.length) {
        form.setFieldsValue({
          usuario: resUser[0].id,
        });
        const _usuario = resUser.map((e) => ({
          ...e,
          nombre_completo: `${e.first_name} ${e.last_name || ''} ${e.second_last_name || ''}`,
        }));
        setUsuarioFound([_usuario[0]]);
      } else {
        message.info('No se encontraron coincidencias');
        setUsuarioFound([]);
      }
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 150,
    },
    {
      titleText: 'Nombre completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
      width: 150,
    },
  ];

  const reset = () => {
    setUsuarioFound([]);
    form.resetFields(['q']);
  };

  const rules = {
    required: [
      { required: true },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!visible
          ? (
            <Table
              cols={columns}
              mobileColumns={[columns[0], columns[1]]}
              data={data}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              rowKey="id"
              baseURI={baseURI}
              permission={permission}
              pagination={false}
              hasAllViewPermission={hasAllViewPermission}
            />
          ) : (
            <Col span={24} style={{ height: '100%' }}>
              <Card
                className="form-container"
                title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Agente`}
                extra={(
                  <FormSubmitControls
                    onFinish={onFinish}
                    onCancel={onCancel}
                    allowSaveAndContinue
                    onCancelText="Cancelar"
                    permission={permission}
                  />
                )}
                bordered={false}
              >
                <Form
                  name="general"
                  layout="vertical"
                  form={form}
                  onFinish={() => onFinish()}
                  scrollToFirstError
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clave"
                        label="clave"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="numero_de_agente"
                        label="Número de agente"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nombre"
                        label="Nombre"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="apellido_paterno"
                        label="Apellido paterno"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="apellido_materno"
                        label="Apellido materno"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="nombre_completo"
                        label="Nombre completo"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="puesto"
                        label="Puesto"
                        rules={rules.required}
                        hasFeedback
                        required
                      >
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="unidad_responsable"
                        rules={rules.required}
                        label="Unidad responsable"
                        hasFeedback
                      >
                        <Select dataSource={departamentos} />
                      </Form.Item>
                    </Col>
                    {configDeInfraccion?.agente_usuario && (
                      <InputSearchPro
                        label="Usuario"
                        tooltip="Búsqueda por Correo del Usuario"
                        name="q"
                        required
                        onClickAdvanced={() => setVisibleAdvancedUser(true)}
                        onPressEnter={() => searchUsuario()}
                        breakPoints={{
                          md: 8,
                        }}
                        resultProps={{
                          name: 'usuario',
                          label: 'usuario',
                          dataSource: usuarioFound,
                          labelProp: 'nombre_completo',
                          onClear: () => reset(),
                          breakPoints: {
                            md: 8,
                          },
                        }}
                      />
                    )}
                    <Col xs={24} sm={24} md={16}>
                      <Form.Item
                        name="observaciones"
                        rules={rules.required}
                        label="Observaciones"
                        hasFeedback
                      >
                        <TextArea autoSize={{ minRows: 3, maxRows: 3 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          visible={visibleAlert}
          content="Agente seleccionado"
          loading={loading}
        />
        <BusquedaAvanzadaUsers
          visible={visibleAdvancedUser}
          setVisible={setVisibleAdvancedUser}
          callback={fetchUser}
          dataExterno={[]}
          setDataExterno={() => { }}
        />
      </Spin>
    </Row>
  );
};

export default Agente;
